import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import FinalPage from './final-page';
import { styles } from './final-page.styles';

export default compose(withStyles(styles))(FinalPage);
